import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, Typography } from "@mui/material";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import { fetchCompanyDetails } from "redux/actions/companyAction";
import RateCard from "pages/rateCard/RateCard";
import Loader from "components/loader/Loader";
import CommonButton from "components/commonButton/CommonButton";
import useModal from "hooks/useModal";
import ConfirmModal from "components/confirmModal/ConfirmModal";
import EmployeeCompanyProfile from "./EmployeeCompanyProfile";
import { getRateCard } from "redux/actions/UserRateCard";
import { billingType, rolesEnum } from "utils/enumObj";
import { getDateFormat } from "utils/utils";
import DownloadIcon from "assets/images/download.png";
import RateCardNew from "pages/rateCardNew/RateCardNew";
import GarageRateDisplay from "./CompanyGarageSlabRateConfig";

const CompanyProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { open, toggle } = useModal();

  const profile =
    localStorage?.getItem("user") && JSON.parse(localStorage?.getItem("user"));
  const isAdmin = rolesEnum.frontdeskRoles?.includes(Number(profile?.role));
  const companyID =
    localStorage.getItem("subCompany")?.length > 0 &&
    JSON.parse(localStorage.getItem("subCompany"));

  useEffect(() => {
    dispatch(fetchCompanyDetails({ id: companyID?.value }));
  }, []);

  const companyProfile = useSelector(
    (state) => state?.userCompanyDetails?.companyDetails,
  );

  const billToSelfLabel =
    companyProfile?.additionalInfo?.billingLabelOverrides?.billToSelf ||
    "Bill to Self";

  const billToCompanyLabel =
    companyProfile?.additionalInfo?.billingLabelOverrides?.billToCompany ||
    "Bill to Company";

  const ContractDetails = useSelector(
    (state) =>
      state?.userCompanyDetails?.companyDetails?.Contracts?.[0]
        ?.ContractDetails,
  );

  const headOffice = companyProfile?.branch?.filter(
    (item) => item.isHeadquarter === true,
  )[0];
  const branches = companyProfile?.branch?.filter(
    (item) => item.isHeadquarter !== true,
  );

  const financeDetails = companyProfile?.Employees?.filter(
    (item, index) => item?.userRole === "Finance",
  );
  const adminDetails = companyProfile?.Employees?.filter(
    (item, index) => item?.userRole === "Admin",
  );

  const vehicleData = ContractDetails?.filter((car) => car.type === "vehicle");
  let vehicleName = vehicleData?.map((ele) => ele?.vehicle);

  const dutyData = ContractDetails?.filter((duty) => duty.type === "dutyType");
  let dutyName = dutyData?.map((ele) => ele?.dutyType);

  const loaderCompnayProfile = useSelector(
    (state) => state?.userCompanyDetails?.loading,
  );

  const combineDates = (startDate, endDate) => {
    if (startDate && endDate) {
      const formattedStartDate = getDateFormat(startDate, "tenure");
      const formattedEndDate = getDateFormat(endDate, "tenure");
      return `${formattedStartDate} - ${formattedEndDate}`;
    }

    return "NA";
  };

  const formatGSTNumber = (gstNumber, sez) => {
    if (gstNumber) {
      if (sez === true) {
        return `${gstNumber} (SEZ)`;
      } else {
        return gstNumber;
      }
    }

    return "NA";
  };

  const details = {
    companyDetails: {
      Address: companyProfile?.address,
      City: companyProfile?.cityName,
      "Pin Code": companyProfile?.pinCode || "NA",
      "Company PAN": companyProfile?.panNumber || "NA",
      "Email ID": companyProfile?.email || "NA",
      "Phone Number": companyProfile?.phoneNumber || "NA",
    },
    gstDetails: {
      "GST Type": companyProfile?.BillingDetail?.gstType || "NA",
      "GST No.": companyProfile?.BillingDetail?.gstNumber || "NA",
      "Billing Name": companyProfile?.BillingDetail?.name || "NA",
      "Billing Address": companyProfile?.BillingDetail?.address || "NA",
      State: companyProfile?.BillingDetail?.state,
    },
    contractDetails: {
      "Contract Date":
        getDateFormat(companyProfile?.Contracts?.[0]?.date, "date") || "NA",
      Tenure: combineDates(
        companyProfile?.Contracts?.[0]?.startDate,
        companyProfile?.Contracts?.[0]?.endDate,
      ),
    },
    headOffice: {
      Cities: headOffice?.cityName || "NA",
      Address: headOffice?.address || "NA",
      State: headOffice?.state || "NA",
      "GST No": formatGSTNumber(headOffice?.gstNumber, headOffice?.sez),
    },
    billingDetails: {
      "Billing Cycle": companyProfile?.Contracts?.[0]?.billingCycle || "NA",
      "Billing Type": companyProfile?.Contracts?.[0]?.invoiceType || "NA",
      "Duty Configuration":
        companyProfile?.Contracts?.[0]?.config === "Point-To-Garage"
          ? " Point to Point with Fixed Garage Run"
          : companyProfile?.Contracts?.[0]?.config === "Garage-To-Garage"
            ? " Garage to Garage"
            : companyProfile?.Contracts?.[0]?.config === "Point-To-Point"
              ? "Point-To-Point"
              : "NA",
      "Fixed Garage Run":
        "₹ " + companyProfile?.Contracts?.[0]?.configRate || "0",
      "Approve or Dispute Duration(in Hr)":
        companyProfile?.Contracts?.[0]?.approvalDuration,
    },
    billingDetailsFixedGarage: {
      "Billing Cycle": companyProfile?.Contracts?.[0]?.billingCycle || "NA",
      "Billing Type": companyProfile?.Contracts?.[0]?.invoiceType || "NA",
      "Duty Configuration":
        companyProfile?.Contracts?.[0]?.config === "Point-To-Garage"
          ? " Point to Point with Fixed Garage Run"
          : companyProfile?.Contracts?.[0]?.config === "Garage-To-Garage"
            ? " Garage to Garage"
            : companyProfile?.Contracts?.[0]?.config === "Point-To-Point"
              ? "Point-To-Point"
              : "NA",
      "Fixed Garage Run":
        "₹ " + companyProfile?.Contracts?.[0]?.configRate || "0",
      "Approve or Dispute Duration(in hr)":
        companyProfile?.Contracts?.[0]?.approvalDuration,
    },
    financeDetails: {
      Name: financeDetails?.[0]?.name || "NA",
      "Email ID": financeDetails?.[0]?.email || "NA",
      "Phone No": financeDetails?.[0]?.phoneNumber || "NA",
    },
    adminDetails: {
      Name: adminDetails?.[0]?.name || "NA",
      "Email ID": adminDetails?.[0]?.email || "NA",
      "Phone No": adminDetails?.[0]?.phoneNumber || "NA",
    },
  };
  const role = localStorage.getItem("role");

  const onClickMoreIcon = () => {
    toggle();
  };

  return (
    <>
      {" "}
      {parseInt(role) !== rolesEnum?.employee ? (
        <Grid container justifyContent={"center"}>
          {loaderCompnayProfile ? (
            <Loader />
          ) : (
            <Grid item xs={12} lg={11} className="bgWhite p30">
              <Box className="justifyBetween">
                <Box className="justifyStart">
                  <ArrowBackIosRoundedIcon
                    className="font24 colorGrey"
                    role="presentation"
                    onClick={() => window.history.go(-1)}
                  />
                  <Typography
                    variant="head3"
                    pl={1}
                    className="colorPrimary fw600"
                  >
                    Company Profile
                  </Typography>
                </Box>
                {role === "adminCompany" && (
                  <CommonButton
                    name={"Edit"}
                    iconType="edit"
                    btnClass={"btnSm btnEdit"}
                    iconPlace="front"
                    onClick={() =>
                      navigate("/company/new-booking", {
                        state: { edit: true, companyProfile: companyProfile },
                      })
                    }
                  />
                )}
              </Box>
              <Box className="bgYellow mt20 justifyStart br5 mb30">
                <Typography variant="head5" className="p20 fw600">
                  {companyProfile?.name}
                </Typography>
              </Box>
              <Grid container className="mb30">
                {Object.entries(details?.companyDetails).map(
                  (objData, index) => (
                    <Grid
                      container
                      item
                      xs={12}
                      lg={objData[0] === "Address" ? 12 : 6}
                      key={index}
                    >
                      <Grid
                        item
                        xs={objData[0] === "Address" ? 2 : 4}
                        className="gridBorder"
                      >
                        <Typography
                          variant={"body2"}
                          className="colorGrey fw400 p20"
                        >
                          {objData[0]}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={objData[0] === "Address" ? 10 : 8}
                        className="gridBorder"
                      >
                        <Typography
                          variant={"body2"}
                          className="colorBlack fw400 p20"
                        >
                          {objData[1]}
                        </Typography>
                      </Grid>
                    </Grid>
                  ),
                )}
              </Grid>

              <Box className="bgGrey justifyStart br5 mb30">
                <Typography variant="head5" className="p20 fw600">
                  Contract Details
                </Typography>
              </Box>
              <Grid container className="mb20">
                {Object.entries(details?.contractDetails).map(
                  (objData, index) => (
                    <Grid
                      container
                      item
                      xs={12}
                      lg={isAdmin ? 5.5 : 6}
                      key={index}
                    >
                      <Grid item xs={4} className="gridBorder">
                        <Typography
                          variant={"body2"}
                          className="colorGrey fw400 p20"
                        >
                          {objData[0]}
                        </Typography>
                      </Grid>
                      <Grid item xs={8} className="gridBorder">
                        <Typography
                          variant={"body2"}
                          className="colorBlack fw400 p20"
                        >
                          {objData[1]}
                        </Typography>
                      </Grid>
                    </Grid>
                  ),
                )}
                {isAdmin && (
                  <Grid
                    item
                    xs={12}
                    lg={1}
                    className="justifyCenter gridBorder"
                  >
                    <img
                      src={DownloadIcon}
                      alt="ArrowDown"
                      className="cursor"
                      onClick={onClickMoreIcon}
                    />
                  </Grid>
                )}
              </Grid>

              {/* ---Office Details */}
              <Box className="bgGrey alignStart br5 mb30">
                <Typography
                  variant="head5"
                  component={"p"}
                  className="p20 fw600"
                >
                  Office Details
                </Typography>
              </Box>
              {headOffice && (
                <Typography variant="body2" className="colorPrimary fw600">
                  Head Office Details
                </Typography>
              )}
              <Grid container className="mb30">
                {Object.entries(details?.headOffice).map((objData, index) => (
                  <Grid container item xs={12} lg={6} key={index}>
                    <Grid item xs={4} className="gridBorder">
                      <Typography
                        variant={"body2"}
                        className="colorGrey fw400 p20"
                      >
                        {objData[0]}
                      </Typography>
                    </Grid>
                    <Grid item xs={8} className="gridBorder">
                      <Typography
                        variant={"body2"}
                        className="colorBlack fw400 p20"
                      >
                        {objData[1]}
                      </Typography>
                    </Grid>
                  </Grid>
                ))}
              </Grid>

              {/* ---Branches--- */}

              {branches?.map((branch, index) => (
                <Grid container className="mb30" key={branch?.id}>
                  <Grid item lg={12}>
                    <Typography
                      variant="body2"
                      className="colorPrimary font16 fw600 pt20"
                    >
                      Branch {index + 1} Office Details
                    </Typography>
                  </Grid>
                  <Grid container item xs={12} lg={6} key={index}>
                    <Grid item xs={4} className="gridBorder">
                      <Typography
                        variant={"body2"}
                        className="colorGrey fw400 p20"
                      >
                        City
                      </Typography>
                    </Grid>
                    <Grid item xs={8} className="gridBorder">
                      <Typography
                        variant={"body2"}
                        className="colorBlack fw400 p20"
                      >
                        {branch?.cityName || "NA"}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container item xs={12} lg={6} key={index}>
                    <Grid item xs={4} className="gridBorder">
                      <Typography
                        variant={"body2"}
                        className="colorGrey fw400 p20"
                      >
                        Address
                      </Typography>
                    </Grid>
                    <Grid item xs={8} className="gridBorder">
                      <Typography
                        variant={"body2"}
                        className="colorBlack fw400 p20"
                      >
                        {branch?.address || "NA"}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container item xs={12} lg={6} key={index}>
                    <Grid item xs={4} className="gridBorder">
                      <Typography
                        variant={"body2"}
                        className="colorGrey fw400 p20"
                      >
                        State
                      </Typography>
                    </Grid>
                    <Grid item xs={8} className="gridBorder">
                      <Typography
                        variant={"body2"}
                        className="colorBlack fw400 p20"
                      >
                        {branch?.state || "NA"}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container item xs={12} lg={6} key={index}>
                    <Grid item xs={4} className="gridBorder">
                      <Typography
                        variant={"body2"}
                        className="colorGrey fw400 p20"
                      >
                        GST
                      </Typography>
                    </Grid>
                    <Grid item xs={8} className="gridBorder">
                      <Typography
                        variant={"body2"}
                        className="colorBlack fw400 p20"
                      >
                        {branch?.gstNumber
                          ? branch?.gstNumber.toUpperCase()
                          : "NA"}{" "}
                        {branch?.sez === true ? "(SEZ)" : null}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} className="gridBorder">
                      <Typography
                        variant={"body2"}
                        className="colorGrey fw400 p20"
                      >
                        Garage Location
                      </Typography>
                    </Grid>
                    <Grid item xs={8} className="gridBorder">
                      <Typography
                        variant={"body2"}
                        className="colorBlack fw400 p20"
                      >
                        {branch?.additionalInfo?.garageAddress
                          ? branch?.additionalInfo?.garageAddress
                          : "NA"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              ))}

              {/* ---Billing */}
              <Box className="bgGrey justifyStart br5 mb30">
                <Typography variant="head5" className="p20 fw600">
                  Billing Details
                </Typography>
              </Box>
              {companyProfile?.Contracts?.[0]?.config === "Garage-To-Garage" ? (
                <Grid container className="mb20">
                  {Object.entries(details?.billingDetails).map(
                    (objData, index) => (
                      <Grid container item xs={12} lg={6} key={index}>
                        <Grid item xs={4} className="gridBorder">
                          <Typography
                            variant={"body2"}
                            className="colorGrey fw400 p20"
                          >
                            {objData[0]}
                          </Typography>
                        </Grid>
                        <Grid item xs={8} className="gridBorder">
                          <Typography
                            variant={"body2"}
                            className="colorBlack fw400 p20"
                          >
                            {objData[1]}
                          </Typography>
                        </Grid>
                      </Grid>
                    ),
                  )}
                  <GarageRateDisplay
                    additionalInfo={companyProfile?.additionalInfo}
                  />
                </Grid>
              ) : (
                <Grid container className="mb20">
                  {Object.entries(
                    companyProfile?.Contracts?.[0]?.config === "Point-To-Garage"
                      ? details?.billingDetailsFixedGarage
                      : details?.billingDetails,
                  ).map((objData, index) => (
                    <Grid container item xs={12} lg={6} key={index}>
                      <Grid item xs={4} className="gridBorder">
                        <Typography
                          variant={"body2"}
                          className="colorGrey fw400 p20"
                        >
                          {objData[0]}
                        </Typography>
                      </Grid>
                      <Grid item xs={8} className="gridBorder">
                        <Typography
                          variant={"body2"}
                          className="colorBlack fw400 p20"
                        >
                          {objData[1]}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              )}

              <Box className="mb20">
                {companyProfile?.Contracts?.[0]?.billingType ===
                billingType?.billToBoth ? (
                  <Grid
                    item
                    xs={12}
                    lg={4}
                    container
                    className="alignItemsCenter"
                  >
                    <Typography
                      variant={"body2"}
                      className="colorBlack fw400  alignItemsCenter"
                    >
                      <span className="colorPrimary">
                        <CheckBoxOutlinedIcon />
                      </span>
                      {/* <span className="ml5">Bill To Credit Card</span> */}
                      <span className="ml5">{billToSelfLabel}</span>
                    </Typography>
                    {/* <Typography
                      variant={"body2"}
                      className="colorBlack fw400  alignItemsCenter ml40"
                    >
                      <span className="colorPrimary">
                        <CheckBoxOutlinedIcon />
                      </span>
                      <span className="ml5">Bill To Company</span>
                      <span className="ml5">{billToSelfLabel}</span>
                    </Typography> */}

                    <Typography
                      variant={"body2"}
                      className="colorBlack fw400  alignItemsCenter ml40"
                    >
                      <span className="colorPrimary">
                        <CheckBoxOutlinedIcon />
                      </span>
                      <span className="ml5">{billToCompanyLabel}</span>
                    </Typography>
                  </Grid>
                ) : companyProfile?.Contracts?.[0]?.billingType ===
                  billingType?.billToCompany ? (
                  <Grid item xs={12} lg={4} className="alignStart">
                    <Typography
                      variant={"body2"}
                      className="colorBlack fw400  alignItemsCenter"
                    >
                      <span className="colorPrimary">
                        <CheckBoxOutlinedIcon />
                      </span>
                      <span className="ml5">{billToCompanyLabel}</span>
                    </Typography>
                  </Grid>
                ) : companyProfile?.Contracts?.[0]?.billingType ===
                  billingType?.billToCreditCard ? (
                  <Grid item xs={12} lg={4} className="alignStart">
                    <Typography
                      variant={"body2"}
                      className="colorBlack fw400  alignItemsCenter"
                    >
                      <span className="colorPrimary">
                        <CheckBoxOutlinedIcon />
                      </span>
                      {/* <span className="ml5">Bill To Credit Card</span> */}
                      <span className="ml5">{billToSelfLabel}</span>
                    </Typography>
                  </Grid>
                ) : null}
              </Box>

              {/* ---Admin Details--- */}
              <Box className="bgGrey justifyStart br5 mb30">
                <Typography variant="head5" className="p20 fw600">
                  Admin Details
                </Typography>
              </Box>
              <Grid container className="mb30">
                {Object.entries(details.adminDetails).map((objData, index) => (
                  <Grid container item xs={12} lg={6} key={index}>
                    <Grid item xs={4} className="gridBorder">
                      <Typography
                        variant={"body2"}
                        className="colorGrey fw400 p20"
                      >
                        {objData[0]}
                      </Typography>
                    </Grid>
                    <Grid item xs={8} className="gridBorder">
                      <Typography
                        variant={"body2"}
                        className="colorBlack fw400 p20"
                      >
                        {objData[1]}
                      </Typography>
                    </Grid>
                  </Grid>
                ))}
              </Grid>

              {/* ---Finance Details--- */}
              <Box className="bgGrey justifyStart br5 mb30">
                <Typography variant="head5" className="p20 fw600">
                  Finance Details
                </Typography>
              </Box>
              <Grid container className="mb30">
                {Object.entries(details.financeDetails).map(
                  (objData, index) => (
                    <Grid container item xs={12} lg={6} key={index}>
                      <Grid item xs={4} className="gridBorder">
                        <Typography
                          variant={"body2"}
                          className="colorGrey fw400 p20"
                        >
                          {objData[0]}
                        </Typography>
                      </Grid>
                      <Grid item xs={8} className="gridBorder">
                        <Typography
                          variant={"body2"}
                          className="colorBlack fw400 p20"
                        >
                          {objData[1]}
                        </Typography>
                      </Grid>
                    </Grid>
                  ),
                )}
              </Grid>
              {/* New Rate Card design(discuss with Vinu) */}
              {isAdmin && (
                <>
                  <Box className="bgGrey justifyStart br5 mb30">
                    <Typography variant="head5" className="p20 fw600">
                      Rate Card
                    </Typography>
                  </Box>
                  <RateCardNew></RateCardNew>
                  {/* <RateCard
                type="company"
                disabled={true}
                id={companyID?.value}
                companyProfile={companyProfile}
                dutyType={dutyName}
                dutyId={dutyName?.[0]?.id}
                vehicleData={vehicleName}
                cityId={headOffice?.city?.id}
                vehicleId={vehicleName?.[0]?.id}
              /> */}
                </>
              )}
            </Grid>
          )}
          <ConfirmModal
            open={open}
            toggle={toggle}
            pageName={"companyDetails"}
            companyProfile={companyProfile}
          />
        </Grid>
      ) : (
        <EmployeeCompanyProfile companyProfile={companyProfile} />
      )}
    </>
  );
};

export default CompanyProfile;
